<script>
  export let title = "Loading...";
  export let hint = "";
</script>

<div
  class="loading_state"
  role="status"
  aria-live="polite"
  aria-label="{title}"
>
  <div class="spinner" aria-hidden="true"></div>
  <div class="text">
    <div class="title">{title}</div>
    {#if hint}
      <div class="hint">{hint}</div>
    {/if}
  </div>
</div>

<style>
  .loading_state {
    align-items: center;
    display: flex;
    font-family: var(--font-family);
    gap: var(--n);
    height: 100%;
    justify-content: center;
    width: 100%;
  }

  .spinner {
    animation: spin 700ms linear infinite;
    border: calc(var(--bw) * 2) solid var(--pax-smoke);
    border-radius: var(--br-round);
    border-top-color: var(--pax-black);
    flex: 0 0 var(--m);
    height: var(--m);
    width: var(--m);
  }

  .text {
    text-align: left;
  }

  .title,
  .hint {
    font-size: var(--n);
  }

  .title {
    color: var(--pax-black);
  }

  .hint {
    color: var(--pax-grey);
    margin-top: var(--xs);
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
